import { getRange, removeSpansAndDivs, shouldConsiderEmpty } from './utils'

export function resetEditor(editorElement: HTMLDivElement, child?: Node) {
  // eslint-disable-next-line no-param-reassign
  editorElement.innerHTML = ''
  if (child) editorElement.appendChild(child)
}

export function removeSelectedContent(editorElement: HTMLDivElement) {
  const range = getRange()
  if (!range) return

  removeSpansAndDivs(editorElement)

  if (shouldConsiderEmpty(editorElement)) {
    resetEditor(editorElement)
    return
  }

  range.deleteContents()
  range.collapse(true)
}
